
import { ref, shallowRef } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  images: {
    key: "images",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const index = ref(0);
  const open = ref(false);
  const items = ref<{
    src: string;
    w: number;
    h: number;
  }[]>([]);
  const photo = shallowRef<HTMLImageElement[]>();
  function showPhotoSwipe(i: number) {
    if (photo.value?.length) {
      items.value = photo.value.map((el: HTMLImageElement) => {
        return {
          src: el.src,
          w: parseInt(el.naturalWidth.toString()),
          h: parseInt(el.naturalHeight.toString())
        };
      });
      open.value = true;
      index.value = i;
    }
  }
  return {
    index,
    open,
    items,
    photo,
    showPhotoSwipe
  };
};
export default __sfc_main;
